module.exports = __webpack_public_path__ + "static/media/certificate.caf363f9.png";